// extracted by mini-css-extract-plugin
export default {"Action":"Container_Action__owXC4","Wrapper":"Container_Wrapper__-aHwb","Table":"Container_Table__HagVD","TableHeader":"Container_TableHeader__W7yYS"};